export const toCommaSeparated = (value: string | number): string => {
  const [integer, decimal] = String(value).split('.');
  const formattedInteger = integer
    ? integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : '0';

  return decimal !== undefined
    ? `${formattedInteger}.${decimal}`
    : formattedInteger;
};
